import { Column } from 'src/shared/components/Semantic/all'
import { Card } from 'src/shared/components/ui/card'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const MacroProblemSection = () => {
  const { t } = useLocalization()

  return (
    <section className="w-full py-20 md:py-24 bg-gradient-to-b from-white via-gray-50 to-gray-100">
      <Column className="w-full max-w-6xl mx-auto px-6 md:px-8 gap-10 md:gap-12">
        <Column className="gap-0">
          <h2 className="text-3xl md:text-4xl font-normal mx-auto text-center !leading-tight text-slate-800">
            {t('Why great merch matters', 'Varför bra merch är viktigt')}
          </h2>
          <p className="text-base md:text-lg text-slate-400 mx-auto text-center mt-2">
            {t(
              'Four shifts companies are feeling.',
              'Fyra förändringar som företag upplever.'
            )}
          </p>
        </Column>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card
            wrapperClassName="md:row-span-2 h-full flex flex-col"
            className="h-full p-6 justify-between overflow-visible relative"
          >
            <div className="relative z-10">
              <h3 className="text-xl text-slate-800 leading-tight">
                {t(
                  "Culture doesn't build itself",
                  'Kultur bygger inte sig självt'
                )}
              </h3>
              <p className="text-slate-500 mt-3 text-sm leading-relaxed">
                {t(
                  'Teams are remote, hybrid, scattered across time zones. Physical touchpoints matter more than ever.',
                  'Team är på distans, hybrida, utspridda över tidszoner. Fysiska kontaktpunkter är viktigare än någonsin.'
                )}
              </p>
            </div>
            <div className="flex items-end justify-end mt-4">
              <img
                src="/about/about-quality-tee.webp?v=white"
                alt="White t-shirt"
                className="w-32 h-40 object-cover rounded-2xl shadow-lg rotate-[-8deg] border-4 border-white"
              />
              <img
                src="/about/about-quality-hoodie.webp?v=white"
                alt="Premium hoodie"
                className="w-36 h-44 object-cover rounded-2xl shadow-xl rotate-[6deg] border-4 border-white -ml-8 z-10"
              />
            </div>
          </Card>

          <Card
            wrapperClassName="h-full flex flex-col"
            className="h-full p-6 justify-between overflow-visible relative"
          >
            <div className="relative z-10">
              <h3 className="text-xl text-slate-800 leading-tight">
                {t(
                  'First impressions are permanent',
                  'Första intryck är bestående'
                )}
              </h3>
              <p className="text-slate-500 mt-2 text-sm leading-relaxed">
                {t(
                  'Employees, candidates, and clients notice the details.',
                  'Anställda, kandidater och kunder märker detaljerna.'
                )}
              </p>
            </div>
            <img
              src="/about/about-quality-mug.webp?v=white"
              alt="Premium mug"
              className="w-24 h-24 object-cover rounded-xl self-end shadow-lg rotate-[8deg] border-4 border-white"
            />
          </Card>

          <Card
            wrapperClassName="h-full flex flex-col"
            className="h-full p-6 justify-between overflow-visible relative"
          >
            <div className="relative z-10">
              <h3 className="text-xl text-slate-800 leading-tight">
                {t('The bar has moved', 'Ribban har höjts')}
              </h3>
              <p className="text-slate-500 mt-2 text-sm leading-relaxed">
                {t(
                  'People expect quality, not just freebies.',
                  'Människor förväntar sig kvalitet, inte bara gratisprylar.'
                )}
              </p>
            </div>
            <img
              src="/about/about-quality-notebook.webp?v=white"
              alt="Premium notebook"
              className="w-24 h-24 object-cover rounded-xl self-end shadow-lg rotate-[-6deg] border-4 border-white"
            />
          </Card>

          <Card
            wrapperClassName="md:col-span-2 h-full flex flex-col"
            className="h-full p-6 flex-col md:flex-row justify-between items-center gap-4 overflow-visible relative"
          >
            <div className="flex-1 relative z-10">
              <h3 className="text-xl text-slate-800 leading-tight">
                {t(
                  'Thoughtfulness is the new standard',
                  'Omtänksamhet är den nya standarden'
                )}
              </h3>
              <p className="text-slate-500 mt-3 text-sm leading-relaxed max-w-sm">
                {t(
                  "Cheap merch tells a story you don't want to tell. Quality products build lasting connections.",
                  'Billig merch berättar en historia du inte vill berätta. Kvalitetsprodukter bygger varaktiga relationer.'
                )}
              </p>
            </div>
            <div className="relative flex items-end shrink-0 mr-0 md:mr-4">
              <img
                src="/about/about-quality-tee.webp?v=white"
                alt="Premium t-shirt"
                className="w-28 h-28 object-cover rounded-xl shadow-lg rotate-[-12deg] border-4 border-white z-10"
              />
              <img
                src="/about/about-quality-tote.webp?v=white"
                alt="Tote bag"
                className="w-28 h-28 object-cover rounded-xl shadow-lg rotate-[10deg] border-4 border-white -ml-6"
              />
              <img
                src="/about/about-quality-bottle.webp?v=white"
                alt="Water bottle"
                className="w-24 h-24 object-cover rounded-xl shadow-lg rotate-[-5deg] border-4 border-white -ml-8 mb-2"
              />
            </div>
          </Card>
        </div>
      </Column>
    </section>
  )
}
